export function toEnglishDigits(str) {
  // convert persian digits [۰۱۲۳۴۵۶۷۸۹]
  var e = "۰".charCodeAt(0);
  str = str.replace(/[۰-۹]/g, function (t) {
    return t.charCodeAt(0) - e;
  });

  // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
  e = "٠".charCodeAt(0);
  str = str.replace(/[٠-٩]/g, function (t) {
    return t.charCodeAt(0) - e;
  });
  return str;
}

const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
const persianMap = persianDigits.split("");
export function convertToPersianNumber(str) {
  const _str = String(str);
  return _str.replace(/\d/g, function (m) {
    return persianMap[parseInt(m)];
  });
}

export const isIranPhoneNumber = (value) =>
  /^(\+98|0098|98|0)?9\d{9}$/.test(value);

export const isEmail = (value) =>
  /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value);
